<template>
    <div class="player player--round">
        <Spinner v-if="showSpinner" />
        <div class="player__right-top">
            <button
                v-if="$isManageApp"
                class="button button--blank button--gray player__copy-src-button"
                @click.prevent="copySrc"
            >
                copy audio
            </button>
        </div>
        <div class="player__control">
            <button
                v-show="!playing"
                type="button"
                class="player__button player__button--play"
                @click.prevent="play"
            >
                <svg
                    width="20"
                    height="24"
                    viewBox="0 0 20 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.9189 10.2996L3.21078 0.237184C2.7464 -0.0439058 2.16977 0.00292533 1.73427 0.00292533C-0.00772719 0.00292533 5.97665e-07 1.37033 5.97665e-07 1.71676V22.2832C5.97665e-07 22.576 -0.00762557 23.9971 1.73427 23.9971C2.16977 23.9971 2.7465 24.0437 3.21078 23.7627L18.9188 13.7005C20.2081 12.9205 19.9853 12 19.9853 12C19.9853 12 20.2082 11.0795 18.9189 10.2996Z"
                        fill="#20d0a9"
                    />
                </svg>
            </button>
            <button
                v-show="playing"
                type="button"
                class="player__button player__button--pause"
                @click.prevent="play"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 535.578 535.578"
                    width="20"
                    height="24"
                >
                    <path
                        d="M231.6 516.278c0 10.658-8.641 19.3-19.3 19.3H106.15c-10.659 0-19.3-8.641-19.3-19.3V19.3c0-10.659 8.641-19.3 19.3-19.3H212.3c10.659 0 19.3 8.641 19.3 19.3v496.978zM448.728 516.278c0 10.658-8.641 19.3-19.3 19.3h-106.15c-10.659 0-19.3-8.641-19.3-19.3V19.3c0-10.659 8.641-19.3 19.3-19.3h106.15c10.659 0 19.3 8.641 19.3 19.3v496.978z"
                        fill="#20d0a9"
                    />
                </svg>
            </button>
            <button
                v-if="rewindButton"
                class="player__rewind"
                type="button"
                @click.prevent="restart"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 489.533 489.533"
                    width="12"
                    height="12"
                >
                    <path
                        d="M268.175 488.161c98.2-11 176.9-89.5 188.1-187.7 14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9l-118.6 87.1c-2 1.5-2 4.4 0 5.9l118.6 87.1c2.7 2 6.7.2 6.7-2.9v-57.5c87.9 1.4 158.3 76.2 152.3 165.6-5.1 76.9-67.8 139.3-144.7 144.2-81.5 5.2-150.8-53-163.2-130-2.3-14.3-14.8-24.7-29.2-24.7-17.9 0-31.9 15.9-29.1 33.6 17.4 109.7 118.7 192 236 178.9z"
                    />
                </svg>
            </button>
        </div>
        <div class="player__wave-wrapper">
            <div ref="wave" class="player__wave"></div>
        </div>
        <div class="player__rate-controls">
            <VDropdown placement="top">
                <button type="button" class="button button--badge player__rate">{{ rate }}x</button>
                <template #popper>
                    <div class="player__rate-list">
                        <button
                            v-for="r in playbackRates"
                            :key="r"
                            v-close-popper
                            type="button"
                            class="player__rate-button button button--badge"
                            @click="setRate(r)"
                        >
                            {{ r }}x
                        </button>
                    </div>
                </template>
            </VDropdown>
        </div>
        <!-- <div class="player__duration">
            {{ duration }}
        </div> -->
    </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js';
import { Dropdown } from 'floating-vue';
import { copyToClipboard } from '../../helpers/functions';

export default {
    name: 'Player',
    components: {
        VDropdown: Dropdown,
    },
    props: {
        src: {
            type: String,
            default: '',
        },
        immidiate: {
            type: Boolean,
            default: false,
        },
        rewindButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            wavesurfer: null,
            playing: false,
            showSpinner: true,
            rate: 1,
            playbackRates: [1, 1.1, 1.2, 1.3, 1.5, 1.7, 2.0],
        };
    },
    watch: {
        src: {
            handler() {
                if (this.src) {
                    this.wavesurfer.load(this.src);
                }
            },
        },
    },
    beforeUnmount() {
        if (this.wavesurfer) {
            this.wavesurfer.destroy();
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.wavesurfer = WaveSurfer.create({
                container: this.$refs.wave,
                barWidth: 2,
                barHeight: 2,
                height: 38,
                progressColor: '#20D0A9',
                waveColor: '#D5D8E5',
                cursorWidth: 0,
                responsive: true,
                hideScrollbar: true,
                backend: 'MediaElement',
                drawingContextAttributes: {
                    desynchronized: false,
                },
                // xhr: {
                //     mode: 'no-cors'
                // }
            });

            this.wavesurfer.on('ready', () => {
                this.showSpinner = false;
                if (this.immidiate) {
                    this.wavesurfer.play();
                }
            });

            this.wavesurfer.on('error', (error) => {
                console.log(error);
            });

            this.wavesurfer.on('play', () => {
                this.playing = true;
                this.$emit('playing');
            });

            this.wavesurfer.on('pause', () => {
                this.playing = false;
                if (this.wavesurfer.getCurrentTime() === this.wavesurfer.getDuration()) {
                    return this.$emit('finished');
                }
                this.$emit('paused');
            });

            this.wavesurfer.on('finished', () => {
                this.playing = false;
                this.$emit('finished');
            });

            if (this.src) {
                this.wavesurfer.load(this.src);
            }
        });
    },
    methods: {
        play() {
            this.wavesurfer.playPause();
        },
        restart() {
            this.wavesurfer.seekTo(0);
        },
        setRate(rate) {
            this.rate = rate;
            this.wavesurfer.setPlaybackRate(rate);
        },
        copySrc() {
            copyToClipboard(this.src);
        },
    },
};
</script>

<style lang="scss" src="./Player.scss"></style>
